<template>
  <div class="menuItems">
    <div class="fs22 ftc22 ftb title">服务中心</div>
    <div class="list">
      <el-menu
        :default-active="curActive"
        class="el-menu-vertical-demo"
        router
        active-text-color="#15D393"
        text-color="#666666"
        @select="selectItem"
      >
        <template v-for="(item, i) in itemList">
          <!-- 有子集 -->
          <el-submenu index="" v-if="item.children.length >= 1" :key="i">
            <template slot="title">{{ item.name }}</template>
            <el-menu-item index="1-4-1">选项1</el-menu-item>
          </el-submenu>
          <!-- 没有子集 -->
          <el-menu-item
            :index="item.path"
            v-if="item.children.length == 0"
            :key="i"
          >
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      itemList: [
        {
          name: "比价管理",
          path: "/servicecenter/pricecomparison",
          children: [],
        },
        {
          name: "保证金管理",
          path: "/servicecenter/margin",
          children: [],
        },
        {
          name: "注册信息",
          path: "/servicecenter/regInfo",
          children: [],
        },
      ],
    };
  },
  computed: {
    curActive() {
      let arr = this.$route.path.split("/");
      let path = "/" + arr[1] + "/" + arr[2];
      return path;
    },
  },
  methods: {
    selectItem(e) {
      console.log(e, 7);
    },
  },
};
</script>

<style lang="less" scoped>
.menuItems {
  width: 100%;
  height: 900px;
  background: #ffffff;
  padding: 30px 0;
  .title {
    padding: 0 35px 30px;
    border-bottom: 1px solid #f0f0f0;
  }
}
.el-menu-item {
  padding-left: 35px !important;
}
.el-menu {
  border-right: none !important;
}
.el-menu-item.is-active {
  background: #e7fbf4 !important;
  position: relative;
}
.el-menu-item.is-active::before {
  background: #15d393;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  padding: 28px 3px;
}
</style>


// WEBPACK FOOTER //
// src/views/servicecenter/menuItem/index.vue